import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import discoverCommunitiesApi from "../api/discoverCommunitiesApi.tsx";
import {
  CommunityBodyTypes,
  CommunityDataType,
  CommunityAggregateDataType,
  CommunityAggregateDataTypes,
} from "../types/discoverCommunitiesTypes.tsx";
import { handleThunkError } from "./handleThunkError";

export const fetchPersonaCommunitiesData = createAsyncThunk(
  "discoverCommunities/fetchPersonaCommunitiesData",
  async (data: CommunityBodyTypes, thunkAPI) => {
    try {
      const response: AxiosResponse<CommunityDataType> =
        await discoverCommunitiesApi.fetchPersonaCommunitiesData(data);
      return response.data;
    } catch (e: unknown) {
      handleThunkError(e, thunkAPI.dispatch, "Failed to fetch communities.");
      return thunkAPI.rejectWithValue("Failed to fetch communities.");
    }
  },
);

interface FetchAggregateSuccessPayload {
  personaId: string | number;
  data: CommunityAggregateDataType;
}

interface FetchAggregateRejectValue {
  personaId: string | number;
  error: string;
}

export const fetchPersonaCommunitiesAggregateData = createAsyncThunk<
  FetchAggregateSuccessPayload,
  CommunityAggregateDataTypes,
  { rejectValue: FetchAggregateRejectValue }
>(
  "discoverCommunities/fetchPersonaCommunitiesAggregateData",
  async (payload, thunkAPI) => {
    const { id: personaId } = payload;
    try {
      const response =
        await discoverCommunitiesApi.fetchPersonaCommunitiesAggregateData(
          payload,
        );
      return { personaId: personaId, data: response.data };
    } catch (e: unknown) {
      handleThunkError(e, thunkAPI.dispatch, "Failed to fetch aggregate data.");
      return thunkAPI.rejectWithValue({
        personaId: personaId,
        error: "Failed to fetch aggregate data.",
      });
    }
  },
);
